import { formatMinorAmount } from '@owner/currency'

import { type FormatFn } from './Format.types'

export const CurrencyFormatter: FormatFn<number> = (value) => {
  return formatMinorAmount(value)
}
